import React from "react"
import { Card, CardContent, Typography, Box, useTheme } from "@mui/material"
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
} from "recharts"
import { fCurrency } from "../../../utils/formatNumbers"
import { format, parseISO } from "date-fns"

export default function SalesByDayChart({
    title = "Vendas por Dia",
    data = [],
}) {
    const theme = useTheme()

    return (
        <Card sx={{ borderRadius: 1, boxShadow: 1 }}>
            <CardContent>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    {title}
                </Typography>

                <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={data}
                            margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
                        >
                            <XAxis
                                dataKey="day"
                                tickFormatter={(str) =>
                                    format(parseISO(str), "dd/MM/yyyy")
                                }
                                tick={{ fontSize: 12 }}
                                angle={-45}
                                textAnchor="end"
                                interval={0}
                            />
                            <YAxis />
                            <Tooltip
                                formatter={(value) => [
                                    fCurrency(value),
                                    "Total em vendas",
                                ]}
                                labelFormatter={(label) =>
                                    format(parseISO(label), "dd/MM/yyyy")
                                }
                                contentStyle={{
                                    backgroundColor:
                                        theme.palette.background.paper,
                                    borderColor: theme.palette.divider,
                                }}
                            />
                            <Bar
                                dataKey="value"
                                radius={[4, 4, 0, 0]}
                                isAnimationActive
                            >
                                {data.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={theme.palette.primary.main}
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            </CardContent>
        </Card>
    )
}
